import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { RuntimeService } from '../../shared/services/runtime.service';

export const licenceGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const runtime = inject(RuntimeService);
  const router = inject(Router);

  if (!runtime.IsDesktopApplication) {
    return router.createUrlTree(['/login']);
  }

  if (authService.isLoggedIn()) {
    return router.createUrlTree(['/load-planning']);
  }

  if (authService.hasLicence()) {
    return router.createUrlTree(['/login']);
  }

  return true;
};
